import React, { useEffect, useRef, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { InputText } from 'primereact/inputtext';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import { OverlayPanel } from 'primereact/overlaypanel';
import './Header.css';


function Header() {
    const navigate = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const op = useRef(null);
    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )
     
    useEffect(() => {
        window
            .matchMedia("(min-width: 768px)")
            .addEventListener('change', e => setMatches(e.matches));
    }, []);
    const SignOff = () => {

        let user = { user_id: null, userName: null, email: null, admin: null, token: null, created: null };
        dispatch({
            type: 'ADD_USER',
            item: user
        });

        localStorage.removeItem('CoderFromMars_User');
        navigate("/");
    }
    const itemRenderer = (item) => (
        <a className="flex align-items-center p-menuitem-link">
            <span className={item.icon} />
            <span className="mx-2">{item.label}</span>
            {item.badge && <Badge className="ml-auto" value={item.badge} />}
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
    );
    const items = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            url: '/Dashboard'
        },
        {
            label: 'Features',
            icon: 'pi pi-star',
             items: [
                {
                    label: 'Doctors',
                     icon: 'pi pi-user-edit',
                    template: itemRenderer
                },
                {
                    label: 'State',
                    icon: 'pi pi-user-edit',
                    template: itemRenderer
                 },
                 {
                     label: 'Braintree Reports',
                     icon: 'pi pi-user-edit',
                     url: '/BraintreeReports'
                 }
             ]
        },
        {
            label: 'Mail Orders',
            icon: 'pi pi-truck',
            url: '/MailOrders'
        },
        {
            label: 'Honeybee Mail Orders',
            icon: 'pi pi-briefcase',
            url: '/MailOrdersHoneybee'
        },
        {
            label: 'Issues',
            icon: 'pi pi-exclamation-triangle',
            badge: 3,
            template: itemRenderer
        }
    ];
    const start = <span className="display-6">HA Control Center</span>;
    const end = (
        <div className="flex align-items-center gap-2">
            <span>{user.userName}</span>
            <Avatar icon="pi pi-user" size="large" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} onClick={(e) => op.current.toggle(e)} />
          
            <OverlayPanel ref={op} dismissable>
                <div className="d-flex flex-column">
                    <span className="p-2" style={{ fontSize: '0.8rem', cursor: 'pointer' }} onClick={() => navigate("/Newuser")}><i className="pi pi-cog mr-1 p-text-secondary p-overlay-badge" style={{ fontSize: '0.8rem' }}></i> New User</span>
                    <span className="p-2" style={{ fontSize: '0.8rem', cursor: 'pointer' }} onClick={SignOff}><i className="pi pi-power-off mr-1 p-text-secondary p-overlay-badge" style={{ fontSize: '0.8rem' }} ></i> Sign Off</span>
                </div>
            </OverlayPanel>
        </div>
    );

    

    return (
        <div className="header" >
            <div className="card">
                <Menubar model={items} start={start} end={end} />
            </div>
          
        </div>


    );

}
export default Header;